import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFileText = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: "1em",
	height: "1em",
	viewBox: "0 0 24 24",
	fill: "none",
	stroke: "currentColor",
	strokeWidth: 2,
	strokeLinecap: "round",
	strokeLinejoin: "round",
	className: "lucide lucide-file-text-icon lucide-file-text",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", { d: "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z" }),
		/* @__PURE__ */ _jsx("path", { d: "M14 2v4a2 2 0 0 0 2 2h4" }),
		/* @__PURE__ */ _jsx("path", { d: "M10 9H8" }),
		/* @__PURE__ */ _jsx("path", { d: "M16 13H8" }),
		/* @__PURE__ */ _jsx("path", { d: "M16 17H8" })
	]
});
export { SvgFileText as ReactComponent };
